module.exports = __webpack_public_path__ + "img/redbones_corner_original.a4188832.jpg";